import React from 'react';
import { Helmet } from 'react-helmet';
import { Link, useLocation } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Addon Brokers</title>
        <meta
          name="description"
          content="The page you are looking for could not be found. Return to the Addon Brokers homepage or contact us for assistance."
        />
        <link rel="canonical" href={path} />
      </Helmet>

      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>

      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundColor: '#005257' }}></div>
        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <span>404</span>
            </li>
          </ul>
          <h2>Page Not Found</h2>
        </div>
      </section>

      <section className="about-two pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="about-two__content">
                <h1 style={{ fontSize: '6rem', lineHeight: 1, color: '#005257', marginBottom: '1rem' }}>
                  404
                </h1>
                <h3 className="block-title__title" style={{ fontSize: '1.5rem', marginBottom: '3rem', color: '#000000ff' }}>
                  Oops! This page could not be found.
                </h3>
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  <Link to="/" className="thm-btn" style={{ marginRight: '10px', maxWidth: '200px' }}>
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
